
export const NavigatorPaths = {
    home: {
        path: 'home',
        name: 'navigation_home'
    },
    home_payouts: {
        path: 'home/payouts',
        name: 'navigation_home_payouts'
    },
    applications: {
        path: 'applications',
        name: 'navigation_provider_applications'
    },
    settings: {
        path: 'settings/:id?',
        name: 'navigation_my_settings'
    },
    experiences: {
        path: 'experiences',
        name: 'navigation_provider_experiences'
    },
    recommendations: {
        path: 'recommendations',
        name: 'navigation_recommendations'
    },
    recommendations_add: {
        path: 'recommendations/add',
        name: 'recommendations_add'
    },
    recommendations_edit: {
        path: 'recommendations/:id',
        name: 'recommendations_edit'
    },
    provider_resources_add: {
        path: 'provider-resources/add',
        name: 'provider_resources_add'
    },
    provider_resources_edit: {
        path: 'provider-resources/:id',
        name: 'provider_resources_edit'
    },
    provider_resources: {
        path: 'provider-resources',
        name: 'navigation_provider_resources'
    },
    experience_addons_add: {
        path: 'experience-addons/add-resources',
        name: 'experience_addons_add'
    },
    experience_addons_edit: {
        path: 'experience-addons/:id',
        name: 'experience_addons_edit'
    },
    experience_addons: {
        path: 'experience-addons',
        name: 'navigation_experience_addons'
    },
    admin_experiences: {
        path: 'admin-experiences',
        name: 'navigation_admin_experiences'
    },
    resale_marketplace: {
        path: 'resale/marketplace',
        name: 'navigation_resale_marketplace'
    },
    resale_bookings: {
        path: 'resale/bookings',
        name: 'navigation_resale_bookings'
    },
    resale_collection: {
        path: 'resale/collection',
        name: 'navigation_resale_collection'
    },
    bookings: {
        path: 'bookings',
        name: 'navigation_provider_bookings'
    },
    booking_detail: {
        path: 'bookings/:id',
        name: 'navigation_provider_bookings_detail'
    },
    calendar: {
        path: 'calendar',
        name: 'navigation_provider_calendar'
    },
    calendar_slot_details: {
        path: 'calendar/:id',
        name: 'navigation_provider_calendar_slot_detail'
    },
    groups: {
        path: 'groups',
        name: 'navigation_provider_groups'
    },
    admin_bookings: {
        path: 'admin/bookings',
        name: 'navigation_admin_bookings'
    },
    admin_bookings_details: {
        path: 'admin/bookings/:id',
        name: 'navigation_admin_bookings_detail'
    },
    admin_groups: {
        path: 'admin/groups',
        name: 'navigation_provider_groups'
    },
    provider_customers: {
        path: 'customers',
        name: 'navigation_provider_customers'
    },
    provider_customer_detail: {
        path: 'customers/:id',
        name: 'navigation_provider_customers_details'
    },
    provider_reviews: {
        path: 'reviews',
        name: 'navigation_provider_reviews'
    },
    provider_reviews_detail: {
        path: 'reviews/:id',
        name: 'navigation_provider_reviews_details'
    },
    admin_provider_customers: {
        path: 'admin/customers',
        name: 'navigation_admin_provider_customers'
    },
    admin_provider_customer_detail: {
        path: 'admin/customers/:id',
        name: 'navigation_admin_provider_customers_details'
    },
    admin_review: {
        path: 'admin/review',
        name: 'navigation_admin_review'
    },
    admin_review_detail: {
        path: 'admin/review/:id',
        name: 'navigation_admin_review_details'
    },
    admin_experience_edit: {
        path: 'admin-experiences/:id',
        name: 'admin_experiences_edit'
    },
    point_of_interests: {
        path: 'point-of-interests',
        name: 'navigation_point_of_interests'
    },
    point_of_interests_detail: {
        path: 'point-of-interests/:id',
        name: 'navigation_point-of-interests_details'
    },
}